module.exports = __webpack_public_path__ + "01_mid_yellow.759e27e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_mid_yellow.png
// module id = TGcN
// module chunks = 0